export default __webpack_public_path__ + "static/media/67_photo.49209b45.jpg";